import React, { useContext } from "react";
import { arrayOf, node, string, bool } from "prop-types";
import VirtualTourButton from "../VirtualTourButton/VirtualTourButton.jsx";
import { VirtualTourIcon, MapPinIcon } from "../../common/icons.jsx";
import { AppContext } from "../FloorPlansPage/AppContext.jsx";

const propTypes = {
  children: node,
  detailButton: node,
  detailUrl: string.isRequired,
  image: node,
  matterportId: string,
  stats: arrayOf(node),
  title: string.isRequired,
};

const LINK_STYLE = "coh-style-link-button---filled";

const Card = props => {
  const {
    children,
    detailButton,
    detailUrl,
    image,
    matterportId,
    selfguidedTour,
    stats,
    title,
  } = props;

  const [appContext] = useContext(AppContext);
  const { hasSightmap } = appContext;

  return (
    <div className="card coh-style-background-light-2">
      {image && (
        // tabIndex="-1" because we only need one of the detailUrl links to be tabbable
        <a href={detailUrl} tabIndex="-1">
          <div className="card__image">{image}</div>
        </a>
      )}
      <div className="card__content">
        <a
          href={detailUrl}
          tabIndex="-1"
          className="card__title  coh-style-heading-3-alt-size"
        >
          {title}
        </a>

        <div className="card__columns">
          <ul className="card__stats coh-style-heading-5-size ">
            {stats.map((stat, i) => {
              return <li key={i}>{stat}</li>;
            })}
          </ul>
          <div className="card__buttons">
            {matterportId && (
              <VirtualTourButton
                className={`${LINK_STYLE} icon-button`}
                matterportId={matterportId}
                aria-label={`${title} Virtual tour`}
              >
                <VirtualTourIcon /> Virtual Tour
              </VirtualTourButton>
            )}
            {hasSightmap === true && (
              <a
                href={detailUrl + "/#map"}
                className={`${LINK_STYLE} icon-button`}
                aria-label={`${title} Map view`}
              >
                <MapPinIcon /> Map View
              </a>
            )}
            {selfguidedTour && (
              <a
                href={selfguidedTour}
                target="_blank"
                rel="noopener noreferrer"
                className={`${LINK_STYLE} icon-button`}
                aria-label={`${title} Tour`}
              >
                Book a Tour
              </a>
            )}
            <a
              href={detailUrl}
              className={`${LINK_STYLE} icon-button`}
              aria-label={`${title} Details`}
            >
              {detailButton}
            </a>
          </div>
        </div>
        {children}
      </div>
    </div>
  );
};

Card.propTypes = propTypes;
export default Card;
